// Field configuration for the generic Admin CRUD manager.
export const ICON_OPTIONS = ['excavation','filling','footing','demolition','rockcutting','dewatering','blasting','chemical','labour','hiring','drill','truck','dozer','layers','steel'];

export const CRUD_CONFIGS = {
  projects: {
    label: 'Projects',
    titleField: 'projectTitle',
    subtitleField: 'client',
    fields: [
      { name: 'projectTitle', label: 'Project Title', type: 'text' },
      { name: 'slug', label: 'Slug', type: 'text' },
      { name: 'client', label: 'Client', type: 'text' },
      { name: 'associatedBrand', label: 'Associated Brand', type: 'text' },
      { name: 'location', label: 'Location', type: 'text' },
      { name: 'serviceCategory', label: 'Work / Service Category', type: 'list' },
      { name: 'workDescription', label: 'Work Description', type: 'text' },
      { name: 'projectYear', label: 'Project Year', type: 'text' },
      { name: 'heroImage', label: 'Hero Image', type: 'image' },
      { name: 'projectImages', label: 'Gallery Images', type: 'imagelist' },
      { name: 'challenge', label: 'Challenge', type: 'textarea' },
      { name: 'solution', label: "Solution", type: 'textarea' },
      { name: 'equipmentUsed', label: 'Equipment Used', type: 'list' },
      { name: 'projectOutcome', label: 'Outcome', type: 'textarea' },
      { name: 'testimonial', label: 'Client Testimonial', type: 'textarea' },
      { name: 'ratingLabel', label: 'Rating Label', type: 'text' },
      { name: 'featured', label: 'Featured', type: 'bool' },
      { name: 'placeholder', label: 'Placeholder Project', type: 'bool' },
      { name: 'order', label: 'Order', type: 'number' },
    ],
  },
  services: {
    label: 'Services',
    titleField: 'title',
    subtitleField: 'category',
    fields: [
      { name: 'title', label: 'Title', type: 'text' },
      { name: 'slug', label: 'Slug', type: 'text' },
      { name: 'category', label: 'Category', type: 'text' },
      { name: 'icon', label: 'Icon', type: 'select', options: ICON_OPTIONS },
      { name: 'image', label: 'Image', type: 'image' },
      { name: 'tagline', label: 'Tagline', type: 'textarea' },
      { name: 'whatWeDo', label: 'What We Do', type: 'textarea' },
      { name: 'whereItMatters', label: 'Where It Matters', type: 'list' },
      { name: 'approach', label: 'Our Approach', type: 'textarea' },
      { name: 'capabilities', label: 'Capabilities', type: 'list' },
      { name: 'equipment', label: 'Equipment', type: 'list' },
      { name: 'featured', label: 'Featured', type: 'bool' },
      { name: 'order', label: 'Order', type: 'number' },
    ],
  },
  equipment: {
    label: 'Equipment',
    titleField: 'name',
    subtitleField: 'category',
    fields: [
      { name: 'name', label: 'Name', type: 'text' },
      { name: 'slug', label: 'Slug', type: 'text' },
      { name: 'model', label: 'Model', type: 'text' },
      { name: 'category', label: 'Category', type: 'text' },
      { name: 'image', label: 'Image', type: 'image' },
      { name: 'description', label: 'Description', type: 'textarea' },
      { name: 'relatedService', label: 'Related Service', type: 'text' },
      { name: 'specs', label: 'Specifications', type: 'textarea' },
      { name: 'hiring', label: 'Available for Hiring', type: 'bool' },
      { name: 'order', label: 'Order', type: 'number' },
    ],
  },
  clients: {
    label: 'Clients',
    titleField: 'name',
    subtitleField: 'tagline',
    fields: [
      { name: 'name', label: 'Name', type: 'text' },
      { name: 'tagline', label: 'Tagline', type: 'text' },
      { name: 'order', label: 'Order', type: 'number' },
    ],
  },
  locations: {
    label: 'Locations',
    titleField: 'name',
    subtitleField: 'label',
    fields: [
      { name: 'name', label: 'Name', type: 'text' },
      { name: 'type', label: 'Type', type: 'select', options: ['office', 'coverage'] },
      { name: 'label', label: 'Label', type: 'text' },
      { name: 'address', label: 'Address', type: 'textarea' },
      { name: 'services', label: 'Services', type: 'list' },
      { name: 'blurb', label: 'Blurb', type: 'textarea' },
      { name: 'mapX', label: 'Map X (%)', type: 'number' },
      { name: 'mapY', label: 'Map Y (%)', type: 'number' },
      { name: 'order', label: 'Order', type: 'number' },
    ],
  },
  leadership: {
    label: 'Leadership',
    titleField: 'name',
    subtitleField: 'role',
    fields: [
      { name: 'name', label: 'Name', type: 'text' },
      { name: 'role', label: 'Role', type: 'text' },
      { name: 'bio', label: 'Bio', type: 'textarea' },
      { name: 'order', label: 'Order', type: 'number' },
    ],
  },
  metrics: {
    label: 'Metrics',
    titleField: 'label',
    subtitleField: 'value',
    fields: [
      { name: 'value', label: 'Value', type: 'text' },
      { name: 'suffix', label: 'Suffix', type: 'text' },
      { name: 'label', label: 'Label', type: 'text' },
      { name: 'order', label: 'Order', type: 'number' },
    ],
  },
  testimonials: {
    label: 'Testimonials',
    titleField: 'author',
    subtitleField: 'project',
    fields: [
      { name: 'author', label: 'Author', type: 'text' },
      { name: 'role', label: 'Role / Company', type: 'text' },
      { name: 'quote', label: 'Quote', type: 'textarea' },
      { name: 'project', label: 'Related Project', type: 'text' },
      { name: 'order', label: 'Order', type: 'number' },
    ],
  },
};

export const SINGLETONS = {
  hero: { label: 'Homepage Hero' },
  about: { label: 'About / Vision' },
  site: { label: 'Site & Contact Settings' },
};
